<app-leveltwo [pageName]="'General Info'">
<div class="General">
  <h3>{{'WhenReassessed.SearchTitle'|translate}}</h3>
  <h5>{{'WhenReassessed.Change'|translate}}</h5>
  <p>{{'WhenReassessed.ChangeOwnershipDesc'|translate}}</p>
  <h5>{{'WhenReassessed.NewConstruction'|translate}}</h5>
  <p>{{'WhenReassessed.NewConstdesc1'|translate}}</p>
  <p>{{'WhenReassessed.NewConstdesc2'|translate}}</p>
  <h5>{{'WhenReassessed.DeclineinValue'|translate}}</h5>
  <p>{{'WhenReassessed.DIV1'|translate}}</p>
  <p>{{'WhenReassessed.DIV2'|translate}}</p>
  <h5>{{'WhenReassessed.DisasterRelief'|translate}}</h5>
  <p>{{'WhenReassessed.Disasterdesc'|translate}}</p>



</div>
</app-leveltwo>

